var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('div',{staticClass:"biz-cell",attrs:{"role":"button"},on:{"click":function($event){return _vm.toBiz()}}},[_c('ImgBlock',{attrs:{"biz":_vm.biz}}),_c('InfoBlock',{attrs:{"biz":_vm.biz}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }